import { Chip, ChipProps } from "@mui/material";
import { memo } from "react";
import { useTranslation } from "react-i18next";

import { TDashboardGenerateExecutionStatus } from "../../../models/dashboard-generate-execution";

const translationPath = "page.dashboardExecutions.status.";

const statusColor: Record<TDashboardGenerateExecutionStatus, ChipProps["color"]> =
  {
    queued: "default",
    processing: "info",
    failed: "error",
    finished: "success",
    finishedwitherror: "warning",
  };

interface IExecutionStatusChipProps {
  status: TDashboardGenerateExecutionStatus;
}

const ExecutionStatusChip = ({ status }: IExecutionStatusChipProps) => {
  const { t } = useTranslation();

  return (
    <Chip
      size="small"
      color={statusColor[status] ?? "default"}
      label={t(translationPath + status)}
    />
  );
};

export default memo(ExecutionStatusChip);
